'use client'

import { useAtomValue } from 'jotai'
import { X } from 'lucide-react'
import {
  cumulativeTransferDetailsAtom,
  errorAtom,
  estimatedRemainingTimeTextAtom,
} from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import { Button } from '../ui/button'
import { StepRemainingTimeText } from './step-remaining-time-text'

interface CompressedHeaderProps {
  onClose?: () => void
  className?: string
}

export default function OverviewHeader({
  onClose,
  className,
}: CompressedHeaderProps) {
  const estimatedRemainingTimeText = useAtomValue(
    estimatedRemainingTimeTextAtom,
  )
  const cumulativeTransferDetails = useAtomValue(cumulativeTransferDetailsAtom)
  const error = useAtomValue(errorAtom)

  return (
    <div
      className={cn(
        'flex items-center py-4 justify-between px-5 bg-foreground rounded-t-3xl',
        className,
      )}
    >
      <div className='size-12 opacity-0' />
      <div className='flex flex-col text-center'>
        <h3 className='text-primary font-semibold text-xl'>Route details</h3>
        {!error ? (
          cumulativeTransferDetails ? (
            <StepRemainingTimeText {...cumulativeTransferDetails} />
          ) : (
            estimatedRemainingTimeText && (
              <span className='text-secondary text-sm leading-5'>
                About{' '}
                <span className='text-primary'>
                  {estimatedRemainingTimeText}
                </span>{' '}
                remaining
              </span>
            )
          )
        ) : null}
      </div>
      <Button
        onClick={onClose}
        type='button'
        className='rounded-full size-12 pointer-events-auto'
      >
        <X />
      </Button>
    </div>
  )
}
